const ROLE_SUPER = 'Super';
const ROLE_ADMIN = 'Admin';
const ROLE_COMPANY_MANAGER = 'Company Manager';
const ROLE_TRAINING_MANAGER = 'Training Manager';
const ROLE_TRAINEE = 'Trainee';
const ROLE_SUPPORT = 'Support';
const ROLE_CTOPS = 'Ctops';

export default {
    ROLE_SUPER,
    ROLE_ADMIN,
    ROLE_COMPANY_MANAGER,
    ROLE_TRAINING_MANAGER,
    ROLE_TRAINEE,
    ROLE_SUPPORT,
    ROLE_CTOPS,
};